import stores from 'store/modules';
import { loggerVue } from 'services/logger';
const SAMPLE_RATE = 60000;

export const actionHeartbeat = async () => {
    const DataLogsStore = stores.DataLogs();

    try {
        DataLogsStore.setLogItem({
            logLevel: 'info',
            timestamp: new Date().toISOString(),
            message: 'Heartbeat',
        });
    } catch (e) {
        loggerVue.error(e, this.$options.__file, 'actionHeartbeat');
    }
};
export const heartbeat = (firstRun = false) => {
    const UserStore = stores.User();

    if (
        UserStore.user?.isLoggedIn &&
        !UserStore.userSettings?.find((setting) => setting.key === 'salesmsg-design-v2')?.settings[
            'active'
        ] &&
        !firstRun
    ) {
        actionHeartbeat();
    }

    setTimeout(heartbeat, SAMPLE_RATE);
};
